(function () {
    'use strict';

    angular.module("imApp").factory("addExistingDocArcService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3756,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
